import React, { Fragment, useContext, useState } from "react";
import { GridLegacy as Grid, Button, CircularProgress } from "@mui/material";
import { FiPrinter } from "react-icons/fi";
import EditableField, { EditableFieldTypes } from "../../editable/EditableField/EditableField";
import { IDropDownListItem } from "../../editable/EditableField/fields/DropDownField";
import { EditableGroupContext } from "../../editable/EditableGroup/EditableGroup";
import ErrorDialog from "../../notifications/errorDialog/ErrorDialog";
import { retrieveValue, storeValue } from "../../../utility/storage";
import { ZebraLabelPrinter } from "..";
import { useTranslation } from "react-i18next";

const LabelPrinterSetting = () => {
    const state = useContext(EditableGroupContext);
    const currentUID = retrieveValue("defaultLabelPrinterUID", "");
    const currentName = retrieveValue("defaultLabelPrinterName", "");
    const [err, setErr] = useState<Error | null>(null);
    const [printing, setPrinting] = useState(false);
    const { t } = useTranslation();

    return (
        <Grid container>

            <ErrorDialog err={err}></ErrorDialog>
            <Grid item sm={12}>
                <div style={{ paddingTop: 20, paddingBottom: 20, textAlign: "center" }}>
                    {t("labels.downloadZebra")}&nbsp;
                    <a target="_blank" rel="noreferrer" href="https://www.zebra.com/us/en/support-downloads/support-eula/browser-print-eula.html">Windows</a>
                    &nbsp;or&nbsp;
                    <a target="_blank" rel="noreferrer" href="https://www.zebra.com/us/en/support-downloads/support-eula/browser-print-eula-osx.html">Mac</a>
                </div>
                {
                    /*
                    <div style={{ padding: 30, textAlign: "center", color: "gray" }}><i>Supported printers include: (Zebra) QLn, ZT200™, ZT400™, ZD500™, ZD400™, LP2824+, GK420, GX420</i></div>
                    */
                }
            </Grid>
            <EditableField<unknown, IDropDownListItem>
                inputType={EditableFieldTypes.terminalField}
                label={t("labels.printerBrowser")}
                onProvide={() => {
                    return {
                        name: currentName,
                        value: currentUID
                    }
                }}
                onChange={(data, value) => {
                    if ((value.value || "").length > 0) {
                        storeValue("defaultLabelPrinterUID", value.value);
                        storeValue("defaultLabelPrinterName", value.name);
                    } else {
                        storeValue("defaultLabelPrinterUID", "");
                        storeValue("defaultLabelPrinterName", "");
                    }

                }}
                onRequestData={async () => {
                    const printers = await ZebraLabelPrinter.getPrinters();
                    const results: IDropDownListItem[] = [];
                    results.push({
                        name: t("reports.optionSelect"),
                        value: ""
                    });
                    for (const printer of printers) {
                        results.push({
                            name: printer.name,
                            value: printer.uid
                        });
                    }
                    return results;
                }}
            />
            <EditableField<unknown, string>
                inputType={EditableFieldTypes.empty}
                label={""}
            />
            {
                state.isEditing == true && (
                    <Grid item>
                        <div style={{ marginTop: 20, marginLeft: 10, marginBottom: 20 }}>
                            <Button
                                disabled={currentUID.length == 0 || printing == true}
                                variant="contained"
                                onClick={async () => {
                                    setPrinting(true);
                                    console.log(currentUID);
                                    try {
                                        await ZebraLabelPrinter.sendToPrinter(currentUID, `^xa^cfa,50^fo100,100^fdTest Print^fs^xz`);

                                    } catch (err: unknown) {
                                        let errorMessage = 'An error occurred.';

                                        if (typeof err === 'string') {
                                            errorMessage = err;
                                        }

                                        setErr(new Error(errorMessage));
                                    }
                                    setPrinting(false);
                                }}><span style={{ marginTop: 3 }}>{printing == true ? <CircularProgress size={14}></CircularProgress> : <FiPrinter fontSize={14}></FiPrinter>}</span>&nbsp;&nbsp;{
                                    printing == true ? <Fragment>{t("labels.printing")}</Fragment> : <Fragment>
                                        {t("labels.testPrint", { name: currentName.length === 0 ? "Default" : currentName })}
                                    </Fragment>
                                }</Button>
                        </div>
                    </Grid>
                )
            }
        </Grid>
    );

}

export default LabelPrinterSetting;